module.exports = __webpack_public_path__ + "static/bg-beb4b715adefe6c0c803e151c0d2a2ba.mp4";